export default {
  rounded: 5,
  circle: '50%',
};
